import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const TopBar = props => {
  return (
    <div
      className={classNames({
        'top-bar': true,
        'single-item': props.singleItem,
        [props.theme]: true,
        [props.className]: props.className
      })}
    >
      <div className='bar-item'>{props.leftChildren}</div>
      {props.rightChildren ? (
        <div className='bar-item right'>{props.rightChildren}</div>
      ) : null}
    </div>
  )
}

TopBar.propTypes = {
  theme: PropTypes.oneOf(['light-bar', 'dark-bar']),
  singleItem: PropTypes.bool
}

TopBar.defaultProps = {
  theme: 'dark-bar'
}

export default TopBar



// WEBPACK FOOTER //
// ./src/ui/bars/top-bar.js